import { hashCode } from "../index";
import { DynamicCssModel } from "../../models/DynamicCssModel";
import { generateGridCss } from "./grid/gridCore";

export function getStoredCss(hashKey: string, cssKey: string, newHash: string): string | null {
    const cachedHash = localStorage.getItem(hashKey);
    if (newHash === cachedHash) {
        return localStorage.getItem(cssKey);
    }
    return null;
}

export function storeCss(hashKey: string, cssKey: string, hash: string, css: string): void {
    localStorage.setItem(hashKey, hash);
    localStorage.setItem(cssKey, css);
}

export function generateCSS(theme: object, dynamicCss: DynamicCssModel): string {
    const settingCssHashKey = "settings-css-hash";
    const settingCssKey = "settings-css";
    const settingsStr = JSON.stringify(dynamicCss);
    const hash = hashCode(settingsStr).toString();

    const storedCss = getStoredCss(settingCssHashKey, settingCssKey, hash);
    if (storedCss) return storedCss;

    const cssForComponents = [];

    if (dynamicCss.HasGridChanges) {
        cssForComponents.push(...generateGridCss(dynamicCss, theme));
    }

    // final css
    const css = cssForComponents.join("\n");
    storeCss(settingCssHashKey, settingCssKey, hash, css);
    return css;
}

export function applyCSS(css: string) {
    const dynamicStyleId = "dynamic-style";
    let styleElement = document.getElementById(dynamicStyleId);
    if (!styleElement) {
        styleElement = document.createElement("style");
        styleElement.id = dynamicStyleId;
        document.head.append(styleElement);
    }
    styleElement.innerHTML = css;
}
